<template>
  <div id="app">
    <div id="wrapper" v-if="isAuthenticated">
      <sidebar-view></sidebar-view>
      <div id="page-wrapper" class="gray-bg sidebar-content">
        <div class="row" style="position: relative;">
          <nav class="navbar navbar-static-top white-bg border-bottom" role="navigation"
          :style="'position: fixed; top: 0; z-index: 2050; right:0; left: ' + getLeftSpacingValue[0]"
          >
            <div class="navbar-header col-lg-6 col-md-6 col-sm-6 col-xs-7" v-if="user.admin">
              <a href="#" class="navbar-minimalize minimalize-styl-2 btn btn-primary"><i class="fa fa-bars"></i></a>
              <TypeAhead :placeholder="'Search for something ...'" class=" col-lg-8 col-md-8 col-sm-8 col-xs-10" accesskey="s"></TypeAhead>
            </div>
            <ul class="nav navbar-top-links navbar-right">
              <li>
                <span><bookmark-manager></bookmark-manager></span>
              </li>
              <li>
                <a>
                  <i class="fa fa-eye red" v-tooltip="'Account details are currently hidden. Click to show them'" v-if="!pv" @click="togglePv(true)"></i>
                  <i class="fa fa-eye-slash green" v-tooltip="'Account details are currently visible. Click to hide them'" v-else  @click="togglePv(false)"></i>
                </a>
              </li>
              <li class="dropdown hidden">
                <a class="dropdown-toggle count-info" data-toggle="dropdown" aria-expanded="false">
                  <i class="fa fa-tasks"></i>
                  <span class="label label-warning">16</span>
                </a>
                <ul class="dropdown-menu dropdown-messages show">
                  <li>
                    <div class="dropdown-message-box">
                      <a>Task 1</a><br>
                      <small>Task 1 description</small>
                    </div>
                  </li>
                  <li>
                    <div class="dropdown-message-box">
                      <a>Task 2</a><br>
                      <small>Task 2 description</small>
                    </div>
                  </li>
                  <li>
                    <div class="dropdown-message-box">
                      <a>Task 3</a><br>
                      <small>Task 3 description</small>
                    </div>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#" @click="logout">
                  <i class="fa fa-sign-out"></i> Log out
                </a>
              </li>
              <li>
                <a class="right-sidebar-toggle" accesskey="h" v-if="user.admin">
                  <i class="fa fa-tasks"></i>
                </a>
              </li>
<!--              <li>-->
<!--                <i :class="'fas fa-socks ' + ($socket.connected ? 'green' : 'red')"></i>-->
<!--              </li>-->
            </ul>
          </nav>
        </div>
        <div class="row wrapper border-bottom white-bg page-heading" :style="'margin-top:' + getLeftSpacingValue[1]">
          <div class="col-lg-12">
            <div v-if="$breadcrumbs[0] && $breadcrumbs[0].meta.breadcrumb">
              <h2>
                {{ $breadcrumbs[0].meta.breadcrumb }}
              </h2>
            </div>
            <h2 v-else>Toolbox</h2>
            <div style="display: flex;">
              <ol style="width: fit-content;" class="breadcrumb" v-if="$breadcrumbs.length">
                <li>
                  <router-link :to="{path: '/'}">Home</router-link>
                </li>
                <li v-for="(crumb, key) in $breadcrumbs" :key="key">
                  <router-link :to="crumb.path" :key="key">{{ crumb.meta.breadcrumb }}</router-link>
                </li>
              </ol>
            </div>
          </div>
        </div>
        <rightside-view></rightside-view>
        <router-view/>
      </div>
    </div>
    <div v-else>
      <login-view></login-view>
    </div>
  </div>
</template>
<script>
import SidebarView from './components/Sidebar/Menu'
import RightsideView from './components/Sidebar/RightSidebar.vue'
import LoginView from './components/Login'
import TypeAhead from './components/Addons/TypeAhead.vue'
import { mapGetters } from 'vuex'
import BookmarkManager from './components/Sidebar/Bookmarks/BookmarkManager.vue'

export default {
  name: 'app',
  data () {
    return {
      casino: window.location.hostname,
      inputSearch: '',
      searchSection: false,
      bodyTagClass: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      pv: 'getPasswordVisibility',
      f: 'getFilters'
    }),
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    getBodyClass () {
      return this.bodyTagClass
    },
    getLeftSpacingValue () {
      if (this.bodyTagClass.includes('mini-navbar')) {
        return ['6.9rem', '13rem']
      } else if (this.bodyTagClass.includes('body-small')) {
        return ['0rem', '13rem']
      } else {
        return ['22rem', '8rem']
      }
    }
  },
  mounted () {
    if (this.isAuthenticated && !this.f.clients) {
      this.$store.dispatch('loadFilters')
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.target.nodeName === 'BODY' && m.attributeName === 'class') {
          this.bodyTagClass = document.body.classList.value
        }
      })
    })

    observer.observe(document.querySelector('body'), {
      attributes: true,
      attributeFilter: ['class']
    })

    // trigger socket login
  },
  components: {
    SidebarView,
    RightsideView,
    LoginView,
    TypeAhead,
    BookmarkManager
  },
  methods: {
    logout () {
      localStorage.clear()
      window.location = '/login'
    },
    togglePv (visibility) {
      this.$store.commit('setPasswordVisibility', visibility)
    }
  }
}
</script>
<style scoped>
/*@import '/sass/style.scss'*/
</style>



// WEBPACK FOOTER //
// src/App.vue